export const skipLinkId = 'skip-link';
export const skipLinkTargetId = 'skip-link--target';
